<div class="admin-emails-modal__backdrop animated fadeIn">
	<div class="admin-emails-modal__wrapper">
		<div class="admin-emails-modal">
			<div class="admin-emails-modal__header">
				<h3 class="admin-emails-modal__title">{{ data?.title }} {{ data?.options['type'] }}</h3>
			</div>
			<div class="admin-emails-modal__content">
				<form class="admin-emails__form admin-emails-form" [formGroup]="form">
					<ng-container formArrayName="emails">
						<p class="admin-emails-form__row-title">Emails:</p>
						<div
							class="admin-emails-form__row admin-emails-form__row--composed"
							*ngFor="let email of emails.controls; let i = index"
						>
							<ng-container [formGroupName]="i">
								<mat-form-field appearance="outline">
									<input
										matInput
										type="text"
										placeholder="example@mail.com"
										formControlName="email"
										autocomplete="off"
										(input)="updateValidation('emails', 'email')"
									/>
								</mat-form-field>
								<button class="admin-emails-form__remove" (click)="onDeleteEmail(i)"></button>
							</ng-container>
						</div>
						<button class="admin-emails-form__add" (click)="onAddEmail()"></button>
					</ng-container>
				</form>
			</div>
			<div class="admin-emails-modal__actions">
				<button class="admin-emails-modal__close" (click)="closeEvent()">Close</button>
				<button class="zesty-modal__create-btn" [disabled]="!checkFormValid(form)" (click)="onSubmit()">Apply</button>
			</div>
		</div>
	</div>
</div>
